<template>
  <div id="insured-detail">
    <div v-if="error">
      <error404
        msg="Nenhum Segurado Encontrado"
        urlBack="/segurados"
      ></error404>
    </div>
    <div v-else-if="data.insured">
      <div class="text-right mb-3">
        <vs-button
          v-if="permissaoHistoricoAlteracoesAssociado"
          color="warning"
          type="gradient"
          @click="abrirModalHistoricoAssociados(data.insured)"
        >
          <vs-icon icon="list" class="mr-3"></vs-icon>
          Histórico Alterações
        </vs-button>
        <vs-button
          color="primary"
          type="gradient"
          class="mb-2 ml-4 text-white forceWhite mr-5"
          v-if="$can('Pode adicionar cobrança avulsa', 'Associados')"
          @click="openModalCobranca()"
        >
          <vs-icon icon-pack="feather" icon="icon-plus" class="mr-3"></vs-icon>
          <vs-icon
            icon-pack="feather"
            icon="icon-dollar-sign"
            class="mr-3"
          ></vs-icon>
          Adicionar Cobrança Avulsa
        </vs-button>
      </div>
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="6"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Segurado</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Código</th>
                  <td colspan="2">{{ data.insured.id }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Tipo</th>
                  <td colspan="2">{{ data.insured.type }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Nome / Nome Social</th>
                  <td colspan="2">{{ data.insured.name }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Nome Social?</th>
                  <td colspan="2">
                    {{ data.insured.socialName ? 'Sim' : 'Não' }}
                  </td>
                </tr>
                <tr v-if="data.insured.socialName">
                  <th class="uppercase">Nome Civil</th>
                  <td colspan="2">{{ data.insured.civilName }}</td>
                </tr>
                <tr>
                  <th class="uppercase">E-mail</th>
                  <td colspan="2">{{ data.insured.email }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Telefone</th>
                  <td colspan="2">{{ data.insured.phone }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Celular</th>
                  <td>
                    {{ data.insured.cellphone }}
                  </td>
                  <td>
                    <a
                      target="_blank"
                      :href="
                        returnLinkWhats2(
                          data.insured.name,
                          data.insured.cellphone,
                        )
                      "
                    >
                      <vs-button
                        radius
                        v-tooltip="'Whatsapp'"
                        color="success"
                        type="gradient"
                        icon-pack="fa"
                        icon="fa-whatsapp"
                        class="d-inline"
                      ></vs-button>
                    </a>
                  </td>
                </tr>
                <tr v-if="data.insured.taxId">
                  <th class="uppercase">
                    {{ data.insured.type === 'Pessoa Física' ? 'CPF' : 'CNPJ' }}
                  </th>
                  <td colspan="2">
                    <p>{{ data.insured.taxId }}</p>
                  </td>
                </tr>
                <tr v-if="data.insured.stateRegistrationNumber">
                  <th class="uppercase">
                    {{ data.insured.type === 'Pessoa Física' ? 'RG' : 'IE' }}
                  </th>
                  <td colspan="2">
                    <p>{{ data.insured.stateRegistrationNumber }}</p>
                  </td>
                </tr>
                <tr v-if="data.insured.gender">
                  <th class="uppercase">Sexo</th>
                  <td colspan="2">
                    <p>{{ data.insured.gender }}</p>
                  </td>
                </tr>
                <tr v-if="data.insured.birthDate">
                  <th class="uppercase">Data de Nascimento</th>
                  <td colspan="2">
                    {{ formatDate(data.insured.birthDate) }}
                  </td>
                </tr>
                <tr v-if="data.insured.driverLicenseNumber">
                  <th class="uppercase">CNH</th>
                  <td colspan="2">{{ data.insured.driverLicenseNumber }}</td>
                </tr>
                <tr v-if="data.insured.driverLicenseCategory">
                  <th class="uppercase">Categoria</th>
                  <td colspan="2">{{ data.insured.driverLicenseCategory }}</td>
                </tr>
                <tr v-if="data.insured.driverLicenseExpiryDate">
                  <th class="uppercase">Data Vencimento CNH</th>
                  <td colspan="2">
                    {{ formatDate(data.insured.driverLicenseExpiryDate) }}
                  </td>
                </tr>
                <tr v-if="data.insured.activationDate">
                  <th class="uppercase">Data de Ativação</th>
                  <td colspan="2">
                    {{ formatDateWithMoment(data.insured.activationDate) }}
                  </td>
                </tr>
                <tr>
                  <th v-if="data.insured.createdAt" class="uppercase">
                    Data de Cadastro
                  </th>
                  <td colspan="2">
                    {{ formatDateWithMoment(data.insured.createdAt) }}
                  </td>
                </tr>
                <tr>
                  <th class="uppercase">Status</th>
                  <td colspan="2">
                    {{
                      data.insured.situation
                        ? data.insured.situation
                        : 'PROSPECT'
                    }}
                  </td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="6"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Endereço</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Cep</th>
                  <td>{{ data.insured.zipCode }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Endereço</th>
                  <td>{{ data.insured.address }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Número</th>
                  <td>{{ data.insured.number }}</td>
                </tr>
                <tr v-if="data.insured.complement">
                  <th class="uppercase">Complemento</th>
                  <td>{{ data.insured.complement }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Bairro</th>
                  <td>{{ data.insured.neighborhood }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Cidade</th>
                  <td>{{ data.insured.city }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Estado</th>
                  <td>{{ data.insured.state }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-card>
            <!-- veiculos -->
            <vs-tabs alignment="fixed">
              <vs-tab label="Veículo">
                <div class="mt-6 mb-6">
                  <div v-if="data.vehicles.length === 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum Veículo Encontrado
                    </vs-alert>
                  </div>
                  <div v-else v-for="item in data.vehicles" :key="item.id">
                    <vs-row>
                      <vs-row class="mt-2 mb-6">
                        <vs-button
                          color="success"
                          type="gradient"
                          class="mr-3 mb-2 text-white forceWhite"
                          @click="openModalFotos(item)"
                          ><vs-icon
                            icon-pack="feather"
                            icon="icon-camera"
                            class="mr-3"
                          ></vs-icon>
                          Fotos e Arquivos
                        </vs-button>

                        <vs-button
                          color="primary"
                          type="gradient"
                          class="mr-3 mb-2 text-white forceWhite"
                          v-if="
                            $can('Editar Dados', 'Veículos') &&
                            agregado &&
                            verificaVeiculoTemComplemento(
                              item.id,
                              'implementos',
                            )
                          "
                          @click="openModalComplemento(item.id, 'agregados')"
                        >
                          <vs-icon
                            icon-pack="feather"
                            icon="icon-truck"
                            class="mr-3"
                          ></vs-icon>
                          Agregados
                        </vs-button>

                        <vs-button
                          color="danger"
                          type="gradient"
                          class="mr-3 mb-2 text-white forceWhite"
                          v-if="
                            $can('Editar Dados', 'Veículos') &&
                            implemento &&
                            verificaVeiculoTemComplemento(
                              item.id,
                              'implementos',
                            )
                          "
                          @click="openModalComplemento(item.id, 'implementos')"
                          ><vs-icon
                            icon-pack="feather"
                            icon="icon-truck"
                            class="mr-3"
                          ></vs-icon>
                          Implementos
                        </vs-button>
                      </vs-row>

                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        :vs-w="hasProducts(item) ? 5 : 12"
                        vs-sm="12"
                        vs-xs="12"
                      >
                        <table class="table table-bordered">
                          <tr>
                            <th class="uppercase">Código</th>
                            <td>{{ item.id }}</td>
                          </tr>
                          <tr>
                            <th class="uppercase">Placa</th>
                            <td>
                              {{
                                item.licensePlate
                                  ? item.licensePlate
                                  : 'Sem Placa'
                              }}
                            </td>
                          </tr>
                          <tr>
                            <th class="uppercase">Chassi</th>
                            <td>{{ item.chassis }}</td>
                          </tr>
                          <tr>
                            <th class="uppercase">É 0 KM?</th>
                            <td>
                              {{
                                Boolean(item.proposal.isZero) ? 'Sim' : 'Não'
                              }}
                            </td>
                          </tr>
                          <tr v-if="Boolean(item.proposal.isZero)">
                            <th class="uppercase">Nº da Nota Fiscal</th>
                            <td>{{ item.proposal.invoice }}</td>
                          </tr>
                          <tr v-if="Boolean(item.proposal.isZero)">
                            <th class="uppercase">Data da Nota Fiscal</th>
                            <td>{{ item.proposal.invoiceDate }}</td>
                          </tr>
                          <tr v-if="Boolean(item.proposal.isZero)">
                            <th class="uppercase">
                              Veículo Saiu da Concessionária?
                            </th>
                            <td>
                              {{
                                item.proposal.outOfDaelership ? 'Sim' : 'Não'
                              }}
                            </td>
                          </tr>
                          <tr
                            v-if="
                              Boolean(item.proposal.isZero) &&
                              item.proposal.outOfDaelership
                            "
                          >
                            <th class="uppercase">
                              Data da Saída da Concessionária
                            </th>
                            <td>
                              {{
                                item.proposal.outOfDealershipDate | formatDate
                              }}
                            </td>
                          </tr>
                          <tr>
                            <th class="uppercase">Marca</th>
                            <td>{{ item.vehicleBrand }}</td>
                          </tr>
                          <tr>
                            <th class="uppercase">Modelo</th>
                            <td>{{ item.vehicleModel }}</td>
                          </tr>
                          <tr>
                            <th class="uppercase">Ano</th>
                            <td>
                              {{
                                item.manufactureYear == '32000'
                                  ? '0Km'
                                  : `${item.manufactureYear}/${item.modelYear}`
                              }}
                            </td>
                          </tr>
                          <tr>
                            <th class="uppercase">Combustível</th>
                            <td>{{ item.fuelType }}</td>
                          </tr>
                          <tr v-if="item.doorCount">
                            <th class="uppercase">Qtd Portas</th>
                            <td>{{ item.doorCount }}</td>
                          </tr>
                          <tr v-if="item.transmissionType">
                            <th class="uppercase">Tipo de Câmbio</th>
                            <td>
                              {{ item.transmissionType }}
                            </td>
                          </tr>
                          <tr v-if="item.engineNumber">
                            <th class="uppercase">Número do Motor</th>
                            <td>{{ item.engineNumber }}</td>
                          </tr>
                          <tr v-if="item.displacement">
                            <th class="uppercase">Cilindradas</th>
                            <td>{{ item.displacement }}</td>
                          </tr>
                          <tr>
                            <th class="uppercase">Código Fipe</th>
                            <td>{{ item.fipeCode }}</td>
                          </tr>
                          <tr>
                            <th class="uppercase">Valor Fipe</th>
                            <td>{{ item.fipeValue | currency }}</td>
                          </tr>
                        </table>
                      </vs-col>
                      <!-- produtos do veículo -->
                      <vs-col
                        v-if="hasProducts(item)"
                        vs-type="flex"
                        vs-justify="center"
                        vs-w="7"
                        vs-sm="12"
                        vs-xs="12"
                      >
                        <table class="table table-bordered">
                          <tr>
                            <th class="uppercase">Produto</th>
                            <th class="uppercase">Prêmio com IOF</th>
                          </tr>
                          <tr
                            v-for="produto in isAuto
                              ? autoProducts
                              : item.vehicleProducts"
                            :key="produto.id"
                          >
                            <td>
                              {{
                                isAuto
                                  ? functions.getAutoProductLabel(produto)
                                  : produto.sgaProductDescription
                              }}
                            </td>
                            <td class="text-right" valing="top">
                              {{
                                isAuto
                                  ? produto.prize.prize
                                  : produto.value | currency
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4"><hr /></td>
                          </tr>
                          <tr v-if="item.vehicleProducts">
                            <th class="uppercase">Prêmio com IOF:</th>
                            <td colspan="3" class="text-right">
                              {{ prize.prizeWithoutInterest | currency }}
                            </td>
                          </tr>
                          <tr v-if="item.vehicleProducts">
                            <th class="uppercase">
                              Adicional de Fracionamento:
                            </th>
                            <td colspan="3" class="text-right">
                              {{ prize.interest | currency }}
                            </td>
                          </tr>
                          <tr v-if="item.vehicleProducts">
                            <th class="uppercase">Prêmio Final:</th>
                            <td colspan="3" class="text-right">
                              {{ prize.prize | currency }}
                            </td>
                          </tr>
                        </table>
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Boletos e Cobranças">
                <div>
                  <vs-row>
                    <vs-col class="text-right">
                      <vs-button
                        color="danger"
                        type="gradient"
                        class="mb-2 text-white forceWhite mr-3"
                        @click="openModalBoletosExcluidos(data.billets)"
                      >
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-dollar-sign"
                          class="mr-3"
                        ></vs-icon>
                        Boletos Excluídos
                      </vs-button>

                      <vs-button
                        color="primary"
                        type="gradient"
                        class="mb-2 text-white forceWhite mr-3"
                        @click="getInsuredBilletCharges()"
                      >
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-refresh-ccw"
                          class="mr-3"
                        ></vs-icon>
                        Refresh
                      </vs-button>
                    </vs-col>
                  </vs-row>

                  <div v-if="!data.billets || !data.billets.length">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum Registro Financeiro Encontrado
                    </vs-alert>
                  </div>

                  <div v-else v-for="item in data.billets" :key="item.id">
                    <vs-collapse
                      type="border"
                      v-if="item.status !== billetStatuses.DELETED"
                    >
                      <vs-collapse-item>
                        <div slot="header">
                          {{ formatDescriptionItem(item) }}

                          <vs-chip
                            v-if="item.status"
                            class="mr-4"
                            :color="getStatusBoletoColor(item.status)"
                          >
                            {{ item.status }}
                          </vs-chip>

                          <vs-chip
                            v-if="item.isLoose"
                            class="mr-4"
                            color="primary"
                          >
                            Avulso
                          </vs-chip>

                          <vs-chip
                            v-if="validaVencido(item)"
                            class="mr-4"
                            color="danger"
                          >
                            Vencido
                          </vs-chip>
                        </div>
                        <vs-row>
                          <vs-col class="flex justify-end items-center">
                            <vs-dropdown
                              vs-trigger-click
                              data-testId="actions-dropdown"
                              class="cursor-pointer"
                            >
                              <div
                                class="rounded-full vs-button-primary vs-button-gradient"
                              >
                                <vs-icon
                                  round
                                  class="m-1"
                                  size="medium"
                                  color="white"
                                  icon="more_horiz"
                                ></vs-icon>
                              </div>

                              <vs-dropdown-menu style="width: 250px">
                                <vs-dropdown-item
                                  v-if="
                                    item.status === 'BAIXADO' ||
                                    item.status === 'BAIXADO COM PENDÊNCIA' ||
                                    item.status === BilletStatuses.SETTLED
                                  "
                                  @click="
                                    dadosHistoricoBaixas = {
                                      idBoleto: item.id,
                                      nossoNumero: item.ourNumber,
                                    }
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-list"
                                    class="mr-3"
                                  ></vs-icon>
                                  Histórico de baixa
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="permissaoHistoricoBoletos"
                                  @click="abriModalHistoricoBoleto(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-list"
                                    class="mr-3"
                                  ></vs-icon>
                                  Histórico de alterações
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="
                                    billetReprocessPermission &&
                                    item.status === billetStatuses.OPEN
                                  "
                                  @click="handleReprocessBillet(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-refresh-cw"
                                    class="mr-3"
                                  ></vs-icon>
                                  Reprocessar boleto
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="
                                    $can(
                                      'Pode editar dados do boleto',
                                      'Associados',
                                    ) && item.status === billetStatuses.OPEN
                                  "
                                  @click="
                                    (itemEditTransacao = item),
                                      (modalAlterarDadosCobranca = true),
                                      (idTipoBoletoSelecionado =
                                        item.billingTypeId),
                                      preencheFormAtualizacao(item)
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-edit"
                                    class="mr-3"
                                  ></vs-icon>
                                  Editar boleto
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="
                                    $can(
                                      'Pode cancelar boletos',
                                      'Associados',
                                    ) && item.status === billetStatuses.OPEN
                                  "
                                  @click="
                                    (itemEditTransacao = item),
                                      (modalCancelarCobranca = true)
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-x-circle"
                                    class="mr-3"
                                  ></vs-icon>
                                  Cancelar boleto
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="
                                    $can(
                                      'Pode baixar cobrança',
                                      'Associados',
                                    ) &&
                                    (item.status === billetStatuses.OPEN ||
                                      item.status === billetStatuses.CANCELED)
                                  "
                                  @click="
                                    (itemEditTransacao = item),
                                      (itemEditTransacao.origem = 'BPTECH'),
                                      (modalBaixarCobranca = true),
                                      preencheFormAtualizacao(item, true)
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-check-circle"
                                    class="mr-3"
                                  ></vs-icon>
                                  Baixar boleto
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="
                                    $can(
                                      'Pode excluir boletos',
                                      'Associados',
                                    ) &&
                                    (item.status === billetStatuses.OPEN ||
                                      item.status === billetStatuses.CANCELED)
                                  "
                                  @click="
                                    (itemEditTransacao = item),
                                      (modalExcluirCobranca = true),
                                      (form.idBoleto = item.id),
                                      (form.motivoCancelamentoExclusao = '')
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-trash-2"
                                    class="mr-3"
                                  ></vs-icon>
                                  Excluir boleto
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="
                                    $can(
                                      'Pode liquidar boletos',
                                      'Associados',
                                    ) && item.status === billetStatuses.OPEN
                                  "
                                  @click="onSettleBillet(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-alert-triangle"
                                    class="mr-3"
                                  ></vs-icon>
                                  Liquidar boleto
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="
                                    $can(
                                      'Pode editar boleto remessa',
                                      'Associados',
                                    ) && isShippingBillet(item)
                                  "
                                  @click="
                                    (itemEditTransacao = item),
                                      (modalAlterarDadosCobranca = true),
                                      (idTipoBoletoSelecionado =
                                        item.billingTypeId),
                                      preencheFormAtualizacao(item)
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-edit"
                                    class="mr-3"
                                  ></vs-icon>
                                  Alterar dados da remessa
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  v-if="
                                    $can(
                                      'Pode excluir boleto remessa',
                                      'Associados',
                                    ) && isShippingBillet(item)
                                  "
                                  @click="
                                    (itemEditTransacao = item),
                                      (modalCancelarCobranca = true),
                                      (form.motivoCancelamentoExclusao = '')
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-trash-2"
                                    class="mr-3"
                                  ></vs-icon>
                                  Cancelar remessa
                                </vs-dropdown-item>
                              </vs-dropdown-menu>
                            </vs-dropdown>

                            <router-link
                              :to="`/ArquivoRemessa`"
                              target="_blank"
                            >
                              <vs-alert
                                v-if="isShippingBillet(item)"
                                class="my-3 text-left"
                                style="height: auto"
                                type="info"
                              >
                                O arquivo remessa não foi gerado. Clique aqui
                                para ser redirecionado.
                              </vs-alert>
                            </router-link>
                            <vs-alert
                              v-if="
                                verificaAlteracao(item.changes) === 'ALTERADO'
                              "
                              class="my-3 text-left"
                              style="height: auto"
                              type="info"
                            >
                              Boleto alterado
                            </vs-alert>
                          </vs-col>
                        </vs-row>
                        <vs-row>
                          <vs-col
                            vs-type="flex"
                            vs-justify="center"
                            vs-w="12"
                            vs-sm="12"
                            vs-xs="12"
                          >
                            <table class="table table-bordered">
                              <tr v-if="item.descricao">
                                <th class="uppercase">Descrição</th>
                                <td>{{ item.descricao }}</td>
                              </tr>
                              <tr v-if="item.ourNumber">
                                <th class="uppercase">Nosso Número</th>
                                <td>{{ item.ourNumber }}</td>
                              </tr>
                              <tr v-if="item.user && item.user.name">
                                <th class="uppercase">Emitido por</th>
                                <td>{{ item.user.name }}</td>
                              </tr>
                              <tr v-if="item.maximumDaysAfterExpiration">
                                <th class="uppercase">
                                  Dias p/ Expiração do Boleto
                                </th>
                                <td>{{ item.maximumDaysAfterExpiration }}</td>
                              </tr>
                              <tr v-if="item.interestDays">
                                <th class="uppercase">
                                  Aplicar Juros a Partir de Quantos Dias
                                </th>
                                <td>{{ item.interestDays }}</td>
                              </tr>
                              <tr v-if="item.dailyInterestRate">
                                <th class="uppercase">Juros diario</th>
                                <td>{{ item.dailyInterestRate }}%</td>
                              </tr>
                              <tr v-if="item.finePercentage">
                                <th class="uppercase">Multa</th>
                                <td>{{ item.finePercentage }}%</td>
                              </tr>
                              <tr>
                                <th class="uppercase">Data de Emissão</th>
                                <td>
                                  {{ formatDateWithMoment(item.issueDate) }}
                                </td>
                              </tr>
                              <tr>
                                <th class="uppercase">Data de Vencimento</th>
                                <td>
                                  {{ formatDateWithMoment(item.dueDate) }}
                                </td>
                              </tr>
                              <tr v-if="item.paymentDate">
                                <th class="uppercase">Data de Pagamento</th>
                                <td>
                                  {{ formatDateWithMoment(item.paymentDate) }}
                                </td>
                              </tr>
                              <tr v-if="item.manualCancellationDate">
                                <th
                                  class="uppercase"
                                  v-if="item.status === billetStatuses.OPEN"
                                >
                                  Dados Alterados
                                </th>
                                <th
                                  class="uppercase"
                                  v-else-if="
                                    item.status === billetStatuses.CANCELED
                                  "
                                >
                                  Cancelamento
                                </th>
                                <th class="uppercase" v-else>Baixa Manual</th>
                                <td>
                                  em
                                  {{
                                    formatDateWithMoment(
                                      item.manualCancellationDate,
                                    )
                                  }}, por
                                  {{ getCancelledByName(item) }}
                                </td>
                              </tr>
                              <tr>
                                <th class="uppercase">Valor</th>
                                <td>{{ item.boletoValue | currency }}</td>
                              </tr>
                              <tr v-if="item.paymentAmount">
                                <th class="uppercase">Valor Pago</th>
                                <td>
                                  {{ item.paymentAmount | currency }}
                                </td>
                              </tr>
                              <tr v-if="item.digitableLine">
                                <th class="uppercase">Linha Digitavel</th>
                                <td>{{ item.digitableLine }}</td>
                              </tr>
                              <tr v-if="item.pixEmv">
                                <th class="uppercase">Código PIX</th>
                                <td
                                  v-tooltip="'Copiar'"
                                  @click="copyToClipboard(item.pixEmv)"
                                >
                                  {{ item.pixEmv }}
                                </td>
                              </tr>
                              <tr v-if="item.digitableLine">
                                <th class="uppercase">Link Boleto</th>
                                <td>
                                  <router-link
                                    target="_blank"
                                    :to="`/Boleto/${item.id}?nn=${item.ourNumber}`"
                                    >Visualizar Boleto
                                  </router-link>
                                </td>
                              </tr>

                              <tr v-if="item.pixImage">
                                <th class="uppercase">Pix Qr Imagem</th>
                                <td>
                                  <VueQr :text="item.pixQrCode" />
                                </td>
                              </tr>
                              <tr v-if="item.pixQrCode">
                                <th class="uppercase">Pix Qr Code</th>
                                <td style="word-break: break-all">
                                  {{ item.pixQrCode }}
                                </td>
                              </tr>
                              <tr v-if="item.remarks">
                                <th class="uppercase">Observação</th>
                                <td style="word-break: break-all">
                                  {{ item.remarks }}
                                </td>
                              </tr>
                              <tr v-if="item.cancellationReason">
                                <th class="uppercase">Motivo Cancelamento</th>
                                <td style="word-break: break-all">
                                  {{ item.cancellationReason }}
                                </td>
                              </tr>
                            </table>
                          </vs-col>
                          <vs-col
                            v-if="item.veiculos"
                            vs-type="flex"
                            vs-justify="center"
                            vs-w="12"
                            vs-sm="12"
                            vs-xs="12"
                          >
                            <table
                              class="table table-bordered"
                              style="border-top: 1px solid black"
                            >
                              <tr>
                                <th class="uppercase">Veiculo</th>
                                <th class="uppercase text-center">Placa</th>
                              </tr>
                              <tr
                                v-for="veiculo in item.veiculos"
                                :key="veiculo.id"
                              >
                                <td>{{ veiculo.veiculoModelo }}</td>
                                <td class="text-center" valing="top">
                                  {{ veiculo.placa }}
                                </td>
                              </tr>
                            </table>
                          </vs-col>
                        </vs-row>
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Cartão de Crédito">
                <div>
                  <CreditCardPurchasesTab
                    :credit-card-purchases="data.creditCardPurchases || []"
                    :main-policy-number="mainPolicyNumber"
                    :apolice-id="apoliceId"
                    :permission-credit-card-refund-history="
                      permissionCreditCardRefundHistory
                    "
                    :permission-review-anti-fraud="permissionReviewAntiFraud"
                    :permission-credit-card-refund="permissionCreditCardRefund"
                    @refresh="getInsuredCreditCardCharges()"
                    @update-credit-card-purchases="
                      data.creditCardPurchases = $event
                    "
                  />
                </div>
              </vs-tab>
              <vs-tab label="Proposta">
                <div>
                  <div v-if="data.proposals.length === 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhuma Proposta Encontrada
                    </vs-alert>
                  </div>
                  <div v-else v-for="item in data.proposals" :key="item.id">
                    <div slot="header" class="text-chip mb-5">
                      {{ item.plate ? item.plate : item.invoice }}
                      {{ item.proposalType }}
                      <vs-chip
                        class="mr-4"
                        :color="
                          functions.getStatusColor(
                            functions.getProposalStatusName(item.statusId),
                          )
                        "
                        >{{
                          functions.getProposalStatusName(item.statusId)
                        }}</vs-chip
                      >
                    </div>
                    <vs-row>
                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-w="8"
                        vs-sm="12"
                        vs-xs="12"
                      >
                        <table class="table table-bordered">
                          <tr v-if="isActivePolicy(item)">
                            <th class="uppercase">Nº da Apólice</th>
                            <td>
                              {{ getFormattedPolicyNumber(item) }}
                            </td>
                          </tr>

                          <tr v-if="isActivePolicy(item)">
                            <th class="uppercase">Status da Apólice</th>
                            <td>
                              {{ getPolicyStatusLabel(item.policy.statusId) }}
                            </td>
                          </tr>

                          <tr v-if="item.proposalNumber">
                            <th class="uppercase">Nº da Proposta</th>
                            <td>{{ getFormattedProposalNumber(item) }}</td>
                          </tr>
                          <tr>
                            <th class="uppercase">Nº da Cotação</th>
                            <td>{{ item.id }}</td>
                          </tr>

                          <tr
                            v-if="
                              data.policies.length > 0 &&
                              data.policies[0].cnsegCi
                            "
                          >
                            <th class="uppercase">CI</th>
                            <td>{{ data.policies[0].cnsegCi }}</td>
                          </tr>

                          <tr v-if="item.createdAt">
                            <th class="uppercase">Data da Cotação</th>
                            <td>
                              {{ formatDateWithMoment(item.createdAt) }}
                            </td>
                          </tr>

                          <tr v-if="item.acceptanceDate">
                            <th class="uppercase">Data do Aceite</th>
                            <td>
                              {{ formatDateWithMoment(item.acceptanceDate) }}
                            </td>
                          </tr>

                          <tr v-if="item.inspectionDate">
                            <th class="uppercase">
                              {{
                                isLifePolicy(item.policy.policyType)
                                  ? 'Data Envio da Documentação'
                                  : 'Data da Vistoria'
                              }}
                            </th>
                            <td>
                              {{ formatDateWithMoment(item.inspectionDate) }}
                            </td>
                          </tr>

                          <tr
                            v-if="
                              item.subscriptionDate ||
                              item.actualSubscriptionDate
                            "
                          >
                            <th class="uppercase">Data da Emissão</th>
                            <td>
                              {{
                                formatDateWithMoment(item.subscriptionDate) ||
                                formatDate(item.actualSubscriptionDate)
                              }}
                            </td>
                          </tr>

                          <tr v-if="!isLifePolicy(item.policy.policyType)">
                            <th class="uppercase">Veículo</th>
                            <td>
                              {{ item.vehicleBrand }}
                              {{ item.vehicleModel }}
                            </td>
                          </tr>

                          <tr v-if="item.policy.cancellationDate">
                            <th class="uppercase">Data de Cancelamento</th>
                            <td>
                              {{ formatDate(item.policy.cancellationDate) }}
                            </td>
                          </tr>
                        </table>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-w="4"
                        vs-sm="12"
                        vs-xs="12"
                      >
                        <div class="flex flex-col">
                          <div class="flex gap-3 py-2">
                            <router-link
                              class="text-white"
                              :to="`/detalheVistoria/${item.id}`"
                            >
                              <vs-button
                                color="dark"
                                type="gradient"
                                class="mr-3 mb-2 text-white w-full h-full"
                              >
                                <vs-icon icon="camera" class="mr-3"></vs-icon>
                                Detalhes da Vistoria
                              </vs-button>
                            </router-link>
                            <a
                              v-if="
                                getProposalPdfContractLink(item) &&
                                item.policy.policyType !==
                                  TIPO_APOLICE.MICRO_VIDA &&
                                item.policy.creationType !== 'ENDORSEMENT'
                              "
                              class="text-white"
                              target="_blank"
                              :href="getProposalPdfContractLink(item)"
                            >
                              <vs-button
                                color="warning"
                                type="gradient"
                                class="mr-3 text-white w-full h-full"
                              >
                                <vs-icon icon="send" class="mr-3"></vs-icon>
                                {{ getOpenProposalLabel(item.policy.statusId) }}
                              </vs-button>
                            </a>
                            <router-link
                              v-if="
                                !getProposalPdfContractLink(item) &&
                                item.policy.policyType !==
                                  TIPO_APOLICE.MICRO_VIDA &&
                                item.policy.creationType !== 'ENDORSEMENT'
                              "
                              class="text-white"
                              target="_blank"
                              :to="
                                getLinkContratoProposta(
                                  item.key,
                                  item.policy.policyType,
                                )
                              "
                            >
                              <vs-button
                                color="warning"
                                type="gradient"
                                class="mr-3 text-white w-full h-full"
                              >
                                <vs-icon icon="send" class="mr-3"></vs-icon>
                                {{ getOpenProposalLabel(item.policy.statusId) }}
                              </vs-button>
                            </router-link>
                          </div>
                        </div>
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
              </vs-tab>
              <vs-tab v-if="permissaoOcorrenciaApolice" label="Ocorrências">
                <div class="w-full flex flex-row justify-end mt-2 mb-2">
                  <vs-button
                    radius
                    icon-pack="feather"
                    icon="icon-plus"
                    class="d-inline"
                    v-tooltip="'Adicionar ocorrência'"
                    @click="abriModalCadastroOcorrencias"
                  >
                  </vs-button>
                </div>
                <ListOccurrences :occurrences="ocorrencias" />
              </vs-tab>
            </vs-tabs>
          </vs-card>
        </vs-col>
      </vs-row>

      <div>
        <Modal
          classContent="popup-loose-charge-overflow"
          class="holamundo"
          id="popup-loose-charge"
          :title="'Adicionar Cobrança Avulsa'"
          :active.sync="modalCobranca"
          @close="closeModais"
        >
          <formCobrancaAvulsa
            :idSegurado="data.insured.id"
            :apolices="data.policies"
            @finished="finalizaAvulsa"
          ></formCobrancaAvulsa>
        </Modal>
      </div>

      <Modal :title="'Logs'" @close="closeModais" :active.sync="modalLogErro">
        <vue-json-pretty :path="'res'" :data="jsonError"></vue-json-pretty>
      </Modal>

      <Modal
        class="holamundo"
        :title="'Excluir Transação'"
        :active.sync="modalExcluirCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Excluir a Transação?
        </vs-alert>

        <div class="vx-col w-full mb-2">
          <label for="" class="vs-input--label">Motivo da Exclusão</label>
          <vs-textarea
            class="w-full"
            name="motivoExclusao"
            id="motivoExclusao"
            v-model="form.motivoCancelamentoExclusao"
            :state="validateState('motivoExclusao')"
            :danger="validateClass('motivoExclusao')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-trash-2"
              class="d-inline"
              @click="excludeBillet()"
            >
              Confirmar
            </vs-button>
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        :title="'Cancelar Transação'"
        :active.sync="modalCancelarCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Cancelar a Transação?
        </vs-alert>

        <div class="vx-col w-full mb-2">
          <label for="" class="vs-input--label">Motivo do Cancelamento</label>
          <vs-textarea
            class="w-full"
            name="motivoCancelamento"
            id="motivoCancelamento"
            v-model="form.motivoCancelamentoExclusao"
            :state="validateState('motivoCancelamento')"
            :danger="validateClass('motivoCancelamento')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-trash-2"
              class="d-inline"
              @click.stop.prevent="cancelBillet()"
              >Confirmar</vs-button
            >
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        :title="'Liquidar Boleto'"
        :active.sync="modalLiquidarCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja liquidar o boleto?
        </vs-alert>

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-alert-triangle"
              class="d-inline"
              @click.stop.prevent="settleBillet()"
              >Confirmar</vs-button
            >
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        :title="'Baixar Cobrança'"
        :active.sync="modalBaixarCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Baixar Cobrança?
        </vs-alert>
        <form
          role="form"
          @submit.stop.prevent="downBillet()"
          v-if="formEditarTransacao.idRegistroFinanceiro"
        >
          <div
            v-if="formasPagamento.length > 0"
            class="vx-col sm:w-1/1 w-full mb-2"
          >
            <label for="" class="vs-select--label">Forma de Pagamento</label>
            <v-select
              :options="formasPagamento"
              name="Forma de Pagamento"
              id="Forma de Pagamento"
              v-model="formEditarTransacao.idFormaPagamentoReal"
              v-validate="{ required: true }"
              label="nomePagamento"
              :state="validateState('Forma de Pagamento')"
              :class="validateClass('Forma de Pagamento')"
            >
            </v-select>
          </div>

          <div class="vx-col sm:w-1/1 w-full mb-2">
            <label for="" class="vs-input--label">Valor Pago</label>
            <money
              class="w-full vs-inputx vs-input--input normal"
              name="Valor"
              id="Valor"
              v-model="formEditarTransacao.valorPago"
              v-validate="{ required: true, min_value: 0.01 }"
              :state="validateState('Valor')"
              :danger="validateClass('Valor')"
            ></money>
          </div>

          <div class="vx-col w-full mb-2">
            <label for="" class="vs-input--label">Data de Pagamento</label>
            <vs-input
              class="w-full"
              name="Data de Pagamento"
              id="Data de Pagamento"
              v-model="formEditarTransacao.dataPagamento"
              v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
              :state="validateState('Data de Pagamento')"
              :danger="validateClass('Data de Pagamento')"
              val-icon-danger="clear"
              v-mask="'##/##/####'"
              danger-text="Preencha este Campo"
              icon-no-border
            />
          </div>
          <vs-alert
            v-if="$validator.errors.all().length > 0"
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <ul>
              <li
                class="mb-2"
                v-for="error in $validator.errors.all()"
                :key="error.id"
              >
                {{ error }}
              </li>
            </ul>
          </vs-alert>
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button
                color="success"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                class="d-inline"
                >Confirmar
              </vs-button>
            </div>
          </div>
        </form>
      </Modal>

      <Modal
        :fullscreen="true"
        class="holamundo"
        :title="'Fotos e Arquivos'"
        :active.sync="modalFotos"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          v-if="fotos.length == 0"
          >Não foram encontrada nenhuma foto para este veículo
        </vs-alert>

        <vs-row v-if="fotos.length > 0">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <div>
              <vs-row class="mt-5" vs-justify="center">
                <vs-col
                  v-for="item in fotos"
                  :key="item.id"
                  type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="3"
                  vs-sm="3"
                  vs-xs="12"
                  class="mb-4"
                >
                  <vs-card>
                    <div class="text-center">
                      <a
                        v-if="verificaExtensaoImagem(item.url)"
                        :href="item.url"
                        target="_blank"
                      >
                        <img :src="item.url" class="foto" width="100%" />
                      </a>
                      <a :href="item.url" target="_blank" v-else>
                        <img
                          v-if="verificaExtensaoArquivo(item.url) == 'pdf'"
                          src="../../../src/assets/images/elements/PDF_file_icon2.png"
                          width="150px"
                          class="text-center"
                        />
                        <img
                          v-if="
                            verificaExtensaoArquivo(item.url) == 'mp4' ||
                            verificaExtensaoArquivo(item.url) == 'mp3' ||
                            verificaExtensaoArquivo(item.url) == 'ogg'
                          "
                          src="../../../src/assets/images/elements/play-button.png"
                          width="150px"
                          class="text-center"
                        />
                        {{ formataUrlLink(item.url) }}</a
                      >
                      <h5 v-if="item.observacao" class="text-center p-4 mb-3">
                        {{ item.observacao }}
                      </h5>
                    </div>
                  </vs-card>
                </vs-col>
              </vs-row>
            </div>
            <br class="break" />
          </vs-col>
        </vs-row>
      </Modal>

      <ModalUpdateBilletData
        :activeModal.sync="modalAlterarDadosCobranca"
        :formEditBillet="formEditarTransacao"
        :originalBilletInfo="originalBilletInfo"
        :billetTypes="tiposBoletos"
        :selectedBilletTypeId="idTipoBoletoSelecionado"
        :paymentMethods="formasPagamento"
        :finishBilletModal="finishBilletModal"
        @close="closeModais"
      />
      <div>
        <Modal
          class="largura-popup"
          :title="`Dados dos ${tiposComplementos}`"
          :active.sync="modalComplementos"
          @close="closeModais"
        >
          <!-- AAA Implementos -->
          <div
            v-if="implemento && tiposComplementos == 'implementos'"
            class="mt-6 mb-6"
          >
            <div v-if="implementos.length === 0">
              <vs-alert style="height: auto" active="true" color="danger">
                Nenhum Implemento adicionado
              </vs-alert>
            </div>
            <vs-collapse v-else type="border">
              <vs-collapse-item
                v-for="implemento in implementos"
                :key="`implemento-${implemento.idComplemento}`"
              >
                <div slot="header">
                  <b>{{ implemento.placa || implemento.chassi }}</b>
                  {{ implemento.marca || '' }}
                  {{ implemento.modelo || '' }}

                  <vs-chip
                    class="mr-4"
                    :color="getStatusColor(implemento.Status)"
                    >{{ implemento.Status }}
                  </vs-chip>
                </div>
                <vs-row>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-w="12"
                    vs-sm="12"
                    vs-xs="12"
                  >
                    <table class="table table-bordered">
                      <tr v-if="implemento.idComplemento">
                        <th class="uppercase">Código</th>
                        <td>{{ implemento.idComplemento }}</td>
                      </tr>
                      <tr v-if="implemento.placa">
                        <th class="uppercase">Placa do Implemento</th>
                        <td>{{ implemento.placa }}</td>
                      </tr>
                      <tr v-if="implemento.descricao">
                        <th class="uppercase">Descrição</th>
                        <td>{{ implemento.descricao }}</td>
                      </tr>
                      <tr v-if="implemento.tipo">
                        <th class="uppercase">Tipo</th>
                        <td>{{ implemento.tipo }}</td>
                      </tr>
                      <tr v-if="implemento.marca">
                        <th class="uppercase">Marca do Implemento</th>
                        <td>{{ implemento.marca }}</td>
                      </tr>
                      <tr v-if="implemento.modelo">
                        <th class="uppercase">Modelo do Implemento</th>
                        <td>{{ implemento.modelo }}</td>
                      </tr>
                      <tr v-if="implemento.valorCobertura">
                        <th class="uppercase">Valor Cobertura</th>
                        <td>R$ {{ implemento.valorCobertura }}</td>
                      </tr>
                      <tr v-if="implemento.numeroNF">
                        <th class="uppercase">número da nota fiscal</th>
                        <td>{{ implemento.numeroNF }}</td>
                      </tr>
                      <tr v-if="implemento.valorNF">
                        <th class="uppercase">Quantidade de Pneus</th>
                        <td>{{ implemento.valorNF | currency }}</td>
                      </tr>
                      <tr v-if="implemento.dataNF">
                        <th class="uppercase">Data da Nota Fiscal</th>
                        <td>
                          {{ formatDate(implemento.comprimento) }}
                        </td>
                      </tr>
                      <tr v-if="implemento.idVeiculoTrator">
                        <th class="uppercase">Código do veículo segurado</th>
                        <td>{{ implemento.idVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="implemento.chassiVeiculoTrator">
                        <th class="uppercase">Chassi do veículo segurado</th>
                        <td>{{ implemento.chassiVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="implemento.placaVeiculoTrator">
                        <th class="uppercase">Placa do veículo segurado</th>
                        <td>{{ implemento.placaVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="implemento.observacao">
                        <th class="uppercase">observação</th>
                        <td>{{ implemento.observacao }}</td>
                      </tr>
                      <tr v-if="implemento.createdAt">
                        <th class="uppercase">Data de cadastro</th>
                        <td>
                          {{ formatDateWithMoment(implemento.createdAt) }}
                        </td>
                      </tr>
                      <tr v-if="implemento.Status">
                        <th class="uppercase">Status</th>
                        <td>{{ implemento.Status }}</td>
                      </tr>
                    </table>
                  </vs-col>
                </vs-row>
              </vs-collapse-item>
            </vs-collapse>
          </div>

          <!-- BBB Agregados -->
          <div
            v-if="agregado && tiposComplementos == 'agregados'"
            class="mt-6 mb-6"
          >
            <div v-if="agregados.length == 0">
              <vs-alert style="height: auto" active="true" color="danger">
                Nenhum agregado encontrado
              </vs-alert>
            </div>
            <vs-collapse v-else type="border">
              <vs-collapse-item
                v-for="agregado in agregados"
                :key="agregado.idComplemento"
              >
                <div slot="header">
                  {{ agregado.placa || agregado.placa || 'Sem Placa e Chassi' }}
                  <vs-chip class="mr-4" :color="getStatusColor(agregado.Status)"
                    >{{ agregado.Status }}
                  </vs-chip>
                </div>
                <vs-row>
                  <vs-row>
                    <table class="table table-bordered">
                      <tr>
                        <th class="uppercase">Código</th>
                        <td>{{ agregado.idComplemento }}</td>
                      </tr>
                      <tr
                        v-if="agregado.nomeGrupo || agregado.nomeGrupoAgregado"
                      >
                        <th class="uppercase">Grupo</th>
                        <td>
                          {{ agregado.nomeGrupo || agregado.nomeGrupoAgregado }}
                        </td>
                      </tr>
                      <tr v-if="agregado.chassi">
                        <th class="uppercase">Chassi</th>
                        <td>{{ agregado.chassi }}</td>
                      </tr>
                      <tr v-if="agregado.placa">
                        <th class="uppercase">Placa</th>
                        <td>{{ agregado.placa }}</td>
                      </tr>
                      <tr v-if="agregado.descricao">
                        <th class="uppercase">Descrição</th>
                        <td>{{ agregado.descricao }}</td>
                      </tr>
                      <tr v-if="agregado.marca">
                        <th class="uppercase">Marca</th>
                        <td>{{ agregado.marca }}</td>
                      </tr>
                      <tr v-if="agregado.modelo">
                        <th class="uppercase">Modelo</th>
                        <td>{{ agregado.modelo }}</td>
                      </tr>
                      <tr v-if="agregado.valorCobertura">
                        <th class="uppercase">Valor Protegido</th>
                        <td>{{ agregado.valorCobertura | currency }}</td>
                      </tr>
                      <tr v-if="agregado.valorMinimoParticipacao">
                        <th class="uppercase">Valor mínimo de participação</th>
                        <td>
                          {{ agregado.valorMinimoParticipacao | currency }}
                        </td>
                      </tr>
                      <tr v-if="agregado.porcentagemParticipacao">
                        <th class="uppercase">Percentual de participação</th>
                        <td>{{ agregado.porcentagemParticipacao }}%</td>
                      </tr>
                      <tr v-if="agregado.numeroNF">
                        <th class="uppercase">Número da nota físcal</th>
                        <td>{{ agregado.numeroNF }}</td>
                      </tr>
                      <tr v-if="agregado.valorNF">
                        <th class="uppercase">Valor da nota físcal</th>
                        <td>{{ agregado.valorNF | currency }}</td>
                      </tr>
                      <tr v-if="agregado.dataNF">
                        <th class="uppercase">Data da nota físcal</th>
                        <td>{{ agregado.dataNF }}</td>
                      </tr>
                      <tr v-if="agregado.diaVencimento">
                        <th class="uppercase">Dia Vencimento</th>
                        <td>{{ agregado.diaVencimento }}</td>
                      </tr>
                      <tr v-if="agregado.valorMensalidade">
                        <th class="uppercase">Valor Mensalidade</th>
                        <td>
                          {{ agregado.valorMensalidade | currency }}
                        </td>
                      </tr>
                      <tr>
                        <th class="uppercase">Vendedor</th>
                        <td>{{ agregado.idVendedor }}</td>
                      </tr>
                      <tr>
                        <th class="uppercase">Data de Ativação</th>
                        <td>
                          {{ formatDate(agregado.createdAt) }}
                        </td>
                      </tr>
                      <tr v-if="agregado.nomePagamento">
                        <th class="uppercase">Forma de Pagamento Mensal</th>
                        <td>{{ agregado.nomePagamento }}</td>
                      </tr>
                      <tr v-if="agregado.idProposta">
                        <th class="uppercase">Código da proposta</th>
                        <td>{{ agregado.idProposta }}</td>
                      </tr>
                      <tr v-if="agregado.idVeiculoTrator">
                        <th class="uppercase">Código do veículo segurado</th>
                        <td>{{ agregado.idVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="agregado.chassiVeiculoTrator">
                        <th class="uppercase">Chassi do veículo segurado</th>
                        <td>{{ agregado.chassiVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="agregado.placaVeiculoTrator">
                        <th class="uppercase">Placa do veículo segurado</th>
                        <td>{{ agregado.placaVeiculoTrator }}</td>
                      </tr>
                    </table>
                  </vs-row>
                  <vs-row class="mt-6">
                    <table class="table table-bordered">
                      <tr>
                        <th class="uppercase">Produto</th>
                        <th class="uppercase">Valor</th>
                        <th class="uppercase">Status</th>
                      </tr>
                      <tr
                        v-for="produto in agregado.produtos"
                        :key="produto.idProduto"
                      >
                        <td>
                          {{ produto.nomeProduto }}
                          <vs-chip
                            v-if="produto.isAdicional"
                            class="mr-4"
                            :color="'primary'"
                            >Adicional
                          </vs-chip>
                          <vs-chip
                            v-if="
                              produto.isMensal == true ||
                              produto.isMensal == null ||
                              produto.isMensal == undefined
                            "
                            class="mr-4"
                            :color="'warning'"
                            >Mensal
                          </vs-chip>
                        </td>
                        <td class="text-center" valing="top">
                          {{ produto.valor | currency }}
                        </td>
                        <td class="text-center" valing="top">
                          <vs-chip
                            class="mr-4"
                            :color="getStatusColor(produto.situacao)"
                            >{{ produto.situacao }}
                          </vs-chip>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4">
                          <hr />
                        </td>
                      </tr>
                      <tr v-if="agregado.produtos">
                        <td>Valor Mensal:</td>
                        <td colspan="3">
                          {{ somaValorTotalMes(agregado.produtos) | currency }}
                        </td>
                      </tr>
                      <tr v-if="agregado.produtos">
                        <td>Valor A vista:</td>
                        <td colspan="3">
                          {{ somaValorTotal(agregado.produtos) | currency }}
                        </td>
                      </tr>
                    </table>
                  </vs-row>
                </vs-row>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </Modal>
      </div>

      <!-- modal form complementos -->
      <div>
        <Modal
          class="holamundo"
          :title="`Editar Dados do ${tiposComplementos}`"
          :active.sync="modalEditarComplemento"
          @close="
            modalEditarComplemento = false;
            resetFormComplemento = true;
          "
        >
          <formComplemento
            :dadosComplemento="complementoSelecionado"
            :editarComplemento="editarDadosComplemento"
            :formasPagamentos="formasPagamentoMensal"
            :resetFormComplemento="resetFormComplemento"
          >
          </formComplemento>
        </Modal>
      </div>

      <modalHistoricoBoleto
        :popupActive="modalHistoricoBoleto"
        :dadosConsulta="dadosConsultaHistorico"
        @close="closeModais"
      ></modalHistoricoBoleto>

      <modalBoletosExcluidos
        :dadosBoletosExcluidos="boletosExcluidos"
        :formataDataUTCAux="formatDate"
        :formataBoletoFisico="formataBoletoFisico"
        :formataData="formatDate"
        :getStatusBoletoColor="getStatusBoletoColor"
      />

      <modalHistoricoBaixas :dadosHistoricoBaixas="dadosHistoricoBaixas" />
      <!-- Modal Histórico -->
      <div>
        <ModalHistorico
          :popupActive="popupActive"
          :tipo="tipoHistorico"
          :nome="nomeHistorico"
          :dadosConsulta="dadosConsultaHistorico"
          @close="fecharModalHistorico"
        ></ModalHistorico>
      </div>

      <ModalCadastroOcorrencias
        ref="ModalCadastroOcorrencias"
        :entityId="apoliceId"
        :popupActive="activeModalCadastroOcorrencias"
        :saveOccurrenceApi="occurrenceApi.savePolicyOccurrence"
        @close="fecharModalCadastroOcorrencias"
      />

      <ModalReprocessBillet
        :activeProp="modalReprocessBillet"
        :gatewayIdProp="gatewayToReprocess"
        @close="closeModalReprocessBillet"
        @getInsuredBilletCharges="getInsuredBilletCharges"
      />
    </div>
  </div>
</template>

<script>
import insuredApi from '@/services/insured.api';
import moment from 'moment';
import { Money } from 'v-money';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import VueQr from 'vue-qr';
import vSelect from 'vue-select';
import { TIPO_APOLICE } from '../../../common/constant/tipo_apolice';
import Modal from '../../components/Modal.vue';
import { BilletActions, BilletStatuses } from '../../constants/billet.constant';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '../../constants/permissions';
import service from '../../services';
import billetApiService from '../../services/billet.api';
import { POLICY_STATUSES, STATUS_PROPOSTA } from '../../utils/constants';
import fileDownload from '../../utils/fileDownload';
import functions from '../../utils/functions';
import utilList from '../../utils/list/index';
import notify from '../../utils/notify';
import modalBoletosExcluidos from '../modais/ModalBoletosExcluidos';
import ModalCadastroOcorrencias from '../modais/ModalCadastroOcorrencias';
import ModalHistorico from '../modais/ModalHistoricoAlteracoes';
import modalHistoricoBaixas from '../modais/ModalHistoricoBaixas.vue';
import ModalReprocessBillet from '../modais/ModalReprocessBillet.vue';
import ModalUpdateBilletData from '../modais/ModalUpdateBilletData.vue';
import dataFunctions from './../../utils/dateConversion';
import formCobrancaAvulsa from './../forms/formCobrancaAvulsa.vue';
import formComplemento from './../forms/FormComplemento.vue';
import modalHistoricoBoleto from './../modais/ModalHistoricoBoleto.vue';
import error404 from './../pages/Error404.vue';
import DOMPurify from 'dompurify';
import ListOccurrences from '../lists/ListOccurrences.vue';
import occurrenceApi from '../../services/occurrence.api';
import CreditCardPurchasesTab from '@/components/installments/CreditCardPurchasesTab.vue';

export default {
  components: {
    error404,
    'v-select': vSelect,
    formCobrancaAvulsa,
    VueJsonPretty,
    Money,
    VueQr,
    formComplemento,
    modalHistoricoBoleto,
    modalBoletosExcluidos,
    modalHistoricoBaixas,
    ModalHistorico,
    Modal,
    ModalCadastroOcorrencias,
    ModalUpdateBilletData,
    ModalReprocessBillet,
    ListOccurrences,
    CreditCardPurchasesTab,
  },
  data() {
    return {
      DOMPurify,
      occurrenceApi,
      getStatusPropostaColor: functions.getStatusColor,
      getYesOrNo: utilList.getSimNao,
      STATUS_PROPOSTA,
      isAuto: false,
      language: 'br',
      autoProducts: [],
      prize: {
        prize: null,
        prizeWithoutInterest: null,
        interest: null,
        iof_value: null,
      },
      resetFormComplemento: false,
      editarDadosComplemento: false,
      tiposComplementos: null,
      complementosSelecionados: [],
      modalEditarComplemento: false,
      modalComplementos: false,
      agregado: false,
      agregados: null,
      implemento: false,
      implementos: null,
      complementoSelecionado: {},
      veiculo: null,
      formasPagamentoMensal: [],
      jsonError: null,
      error: false,
      filtro: null,
      modalCobranca: false,
      modalLogErro: false,
      modalCancelarCobranca: false,
      modalAlterarDadosCobranca: false,
      modalBaixarCobranca: false,
      modalFotos: false,
      modalAnexarArquivo: false,
      modalHistotico: false,
      modalHistoricoBoleto: false,
      modalReprocessBillet: false,
      gatewayToReprocess: null,
      activeModalCadastroOcorrencias: false,
      dadosConsultaHistorico: {},
      modalExcluirCobranca: false,
      modalLiquidarCobranca: false,
      fotos: [],
      itemEditTransacao: null,
      regionais: [],
      consultores: [],
      status: [],
      grupos: [],
      restricoes: [],
      produtos: [],
      listaCores: [],
      listaCombustiveis: [],
      formasPagamento: [],
      tiposBoletos: [],
      boletosExcluidos: [],
      dadosHistoricoBaixas: {},
      idTipoBoletoSelecionado: null,
      form: {},
      originalBilletInfo: {
        originalValue: null,
        originalDueDate: null,
        originalDuePaymentDate: null,
      },
      formEditarTransacao: {
        idRegistroFinanceiro: null,
        idTipoPagamentoEmpresa: null,
        idTipoBoleto: null,
        dataVencimento: null,
        dataVencimento2: null,
        idCarteira: null,
        nossoNumero: null,
        valor: null,
        idFormaPagamentoReal: null,
        dataPagamento: null,
        valorPago: null,
        mesReferente: null,
      },
      popupActive: false,
      tipoHistorico: 'Veículo',
      nomeHistorico: '',
      ocorrencias: [],
      apoliceId: null,
      data: {
        insured: null,
        vehicles: [],
        policies: [],
        proposals: [],
        billets: [],
        creditCardPurchases: [],
      },
      mainPolicyNumber: null,
      policyType: null,
    };
  },
  computed: {
    BilletStatuses() {
      return BilletStatuses;
    },
    TIPO_APOLICE() {
      return TIPO_APOLICE;
    },
    functions() {
      return functions;
    },
    billetStatuses() {
      return BilletStatuses;
    },
    billetReprocessPermission() {
      return this.$can(
        PERMISSIONS_ACTIONS.BILLET_REPROCESS,
        PERMISSIONS_NAMES.INSUREDS,
      );
    },
    permissaoHistoricoBoletos() {
      return this.$can('Histórico Boletos', 'Associados');
    },
    permissaoHistoricoAlteracoesAssociado() {
      return this.$can('Historico Alterações', 'Associados');
    },
    permissaoOcorrenciaApolice() {
      return this.$can('Ocorrência Apólice', 'Associados');
    },
    permissionCreditCardRefund() {
      return this.$can('Pode Restituir Cartão Credito', 'Associados');
    },
    permissionReviewAntiFraud() {
      return this.$can('Dados de antifraude', 'Associados');
    },
    permissionCreditCardRefundHistory() {
      return this.$can('Pode Ver Restituições Cartão Credito', 'Associados');
    },
  },
  methods: {
    closeModalReprocessBillet() {
      this.modalReprocessBillet = false;
      this.gatewayToReprocess = null;
    },
    handleReprocessBillet(billet) {
      this.gatewayToReprocess = billet.gatewayId;
      this.modalReprocessBillet = true;
    },
    async getOriginalValue(billetId) {
      let originalValue = null;
      try {
        this.$vs.loading();
        const value = await billetApiService.getOriginalValueBillet(billetId);
        if (value) {
          originalValue = value;
        }
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível buscar os dados originais do boleto',
        );
        this.closeModais();
      } finally {
        this.$vs.loading.close();
      }
      return originalValue;
    },
    hasProducts(item) {
      return (
        (this.isAuto && this.autoProducts.length > 0) ||
        (!this.isAuto &&
          item.vehicleProducts &&
          item.vehicleProducts.length > 0)
      );
    },
    isActivePolicy(item) {
      return (
        item.policy.statusId !== POLICY_STATUSES.OPEN.id &&
        (item.statusId === STATUS_PROPOSTA.FINALIZADO.id ||
          item.statusId === STATUS_PROPOSTA.APOLICE_FINALIZADA.id ||
          item.statusId === STATUS_PROPOSTA.APOLICE_CANCELADA.id)
      );
    },
    getFormattedPolicyNumber(item) {
      return functions.formatStarNumber(
        item.policy.activatedPolicyNumber,
        item.policy.policyType,
        'POLICY',
      );
    },
    getFormattedProposalNumber(item) {
      return functions.formatStarNumber(
        item.proposalNumber,
        item.policy.policyType,
        'PROPOSAL',
      );
    },
    getPolicyStatusLabel(policyStatus) {
      const statusKey = Object.keys(POLICY_STATUSES).find(
        (statusKey) => POLICY_STATUSES[statusKey].id === policyStatus,
      );
      return POLICY_STATUSES[statusKey].name;
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          notify.notifySuccess(
            this.$vs,
            'Código PIX copiado para a área de transferência.',
          );
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao copiar');
        });
    },
    verificaVeiculoTemComplemento(idVeiculoTrator, nomeObj) {
      const complementos = this[nomeObj].filter(
        (complemento) => complemento.idVeiculoTrator == idVeiculoTrator,
      );

      const temComplemento = complementos.length > 0 ? true : false;
      return temComplemento;
    },
    abrirModalEditarComplemento(item) {
      this.modalEditarComplemento = true;
      this.complementoSelecionado = item;
      this.resetFormComplemento = false;
    },
    openModalComplemento(idVeiculo, tiposComplementos) {
      this.tiposComplementos = tiposComplementos;
      this.filtraComplementosAssociadosVeiculo(idVeiculo);
      this.modalComplementos = true;
    },
    filtraComplementosAssociadosVeiculo(idVeiculo) {
      const _tiposComplementos = this.tiposComplementos;
      this.complementosSelecionados = this[_tiposComplementos].filter(
        (complemento) => complemento.idVeiculoTrator == idVeiculo,
      );
    },
    formataBoletoFisico(obj) {
      if (obj.paymentMethod == 'Boleto' && obj.boletoFisico == 1) return 'Sim';
      else return 'Não';
    },
    formatDate(date) {
      return dataFunctions.converteISOToDate(date);
    },
    formatDateWithMoment(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getCancelledByName(item) {
      if (item.cancelledByUser) {
        return item.cancelledByUser.name;
      }
      return item.cancelledBy;
    },
    returnLinkWhats2(nome, celular) {
      let texto = `Olá ${nome}, tudo bem? 😉 \nSomos da *${this.data.insured.company.name}*, `;
      let textoEncode = encodeURI(texto);

      let link = '';
      link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;

      return link;
    },
    disparaLink(item) {
      let isBrowser = null;

      let nome = item.nome.split(' ')[0];
      let celular = item.telefone
        .replace('(', '')
        .replace(')', '')
        .replace(' ', '')
        .replace('-', '');
      let texto = `Olá ${nome}, tudo bem? A cotação da associação ${item.empresa} para proteger seu veículo foi gerada, você consegue aceita-la e fazer sua vistoria tudo por lá, acesse ${window.location.origin}/proposta/${item.chave}`;
      let textoEncode = encodeURI(texto);

      let link = '';
      if (isBrowser == true)
        link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;
      else link = `whatsapp://send?phone=55${celular}&text=${textoEncode}`;
      window.open(link, '_blank');
    },
    buscaFormasPagamentoDisponiveisAlteracaoBoleto() {
      service
        .post(
          'CarteiraCobranca',
          'buscaFormasPagamentoDisponiveis',
          this.formEditarTransacao,
        )
        .then((res) => {
          this.formasPagamento = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    async preencheFormAtualizacao(item, finalizacao) {
      this.formasPagamento = [];
      this.originalBilletInfo.originalValue =
        item.originalValue || (await this.getOriginalValue(item.id));
      this.originalBilletInfo.originalDueDate = moment(item.originalDueDate)
        .utc()
        .format('DD/MM/YYYY');
      this.originalBilletInfo.originalDuePaymentDate = moment(
        item.originalDueDate,
      )
        .add(parseInt(item.maximumDaysAfterExpiration), 'days')
        .utc()
        .format('DD/MM/YYYY');
      this.formEditarTransacao.idRegistroFinanceiro = item.id;
      this.formEditarTransacao.valor = item.boletoValue;
      this.formEditarTransacao.nossoNumero = item.ourNumber;
      this.formEditarTransacao.idCarteira = item.walletId;
      this.formEditarTransacao.formaPagamento = item.paymentMethod;
      this.formEditarTransacao.idTipoBoleto = item.billingTypeId;
      this.formEditarTransacao.mesReferente = item.referenceMonth;
      this.formEditarTransacao.dataVencimento = moment(item.dueDate)
        .utc()
        .format('DD/MM/YYYY');
      if (finalizacao) {
        this.formEditarTransacao.dataPagamento = moment()
          .utc()
          .format('DD/MM/YYYY');
        this.formEditarTransacao.valorPago = item.boletoValue;
        this.buscaFormasPagamentoDisponiveisAlteracaoBoleto();
      }
      this.formEditarTransacao = { ...this.formEditarTransacao };
      if (!item.idGalax) this.buscaFormasPagamentoDisponiveisAlteracaoBoleto();
    },
    verificaExtensaoImagem(link) {
      if (link) {
        if (link.indexOf('short.hinova') > 0) return true;
        if (link.split('/')[0] == 'data:image') return true;
        var ext = link.split('.').pop();
        if (ext == 'png' || ext == 'jpeg' || ext == 'jpg') return true;
        else return false;
      } else return false;
    },
    formataUrlLink(url) {
      if (url) return url.split('/').pop();
    },
    finishBilletModal(success, message) {
      if (success) {
        this.closeModais();
        this.getInsuredBilletCharges();

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: message,
          color: 'success',
        });
        return;
      }

      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: message,
        color: 'danger',
      });
    },

    async downBillet() {
      this.$vs.loading();
      const payload = {
        action: BilletActions.CONFIRM_PAYMENT,
        paymentMethod:
          this.formEditarTransacao.idFormaPagamentoReal.id_tipoPagamento,
        paymentAmount: this.formEditarTransacao.valorPago,
        paymentDate: this.formEditarTransacao.dataPagamento,
      };

      try {
        await billetApiService.updateBillet(
          this.formEditarTransacao.idRegistroFinanceiro,
          payload,
        );
        this.finishBilletModal(true, 'Boleto baixado com sucesso');
      } catch (error) {
        const apiMessage =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;
        this.finishBilletModal(false, apiMessage || 'Falha ao baixar boleto');
      } finally {
        this.$vs.loading.close();
      }
    },

    async cancelBillet() {
      this.$vs.loading();
      const payload = {
        action: BilletActions.CANCEL,
        cancelationReason: this.form.motivoCancelamentoExclusao || '',
      };

      try {
        await billetApiService.updateBillet(this.itemEditTransacao.id, payload);
        this.finishBilletModal(true, 'Boleto cancelado com sucesso');
      } catch (error) {
        const apiMessage =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;
        this.finishBilletModal(false, apiMessage || 'Falha ao cancelar boleto');
      } finally {
        this.$vs.loading.close();
      }
    },
    onSettleBillet(item) {
      this.itemEditTransacao = item;
      this.modalLiquidarCobranca = true;
      this.form.idBoleto = item.id_boleto;
      this.form.motivoCancelamentoExclusao = '';
    },
    async settleBillet() {
      this.$vs.loading();
      const payload = {
        action: BilletActions.SETTLE,
      };

      try {
        await billetApiService.updateBillet(this.itemEditTransacao.id, payload);
        this.finishBilletModal(true, 'Boleto liquidado com sucesso');
      } catch (error) {
        const apiMessage =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;
        this.finishBilletModal(false, apiMessage || 'Falha ao liquidar boleto');
      } finally {
        this.$vs.loading.close();
      }
    },

    async excludeBillet() {
      this.$vs.loading();
      const payload = {
        action: BilletActions.EXCLUDE,
        cancelationReason: this.form.motivoCancelamentoExclusao || '',
      };

      try {
        await billetApiService.updateBillet(this.itemEditTransacao.id, payload);
        this.finishBilletModal(true, 'Boleto excluído com sucesso');
      } catch (error) {
        const apiMessage =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;
        this.finishBilletModal(false, apiMessage || 'Falha ao excluir boleto');
      } finally {
        this.$vs.loading.close();
      }
    },

    sendAcaoTransacao(acao) {
      var objSend = {};
      objSend.acao = acao + 'r';
      objSend.idRegistroFinanceiro = this.itemEditTransacao.id;
      objSend.idCarteira = this.itemEditTransacao.walletId;
      objSend.nossoNumero = this.itemEditTransacao.ourNumber;
      objSend.idTipoBoleto = this.itemEditTransacao.billingTypeId;
      objSend.idRemessaBoleto = this.itemEditTransacao.id;
      objSend.idRemessa = this.itemEditTransacao.remittanceId;
      objSend.galaxPayId = this.itemEditTransacao.idGalax;
      objSend.jsonFacilitador = this.formEditarTransacao;
      objSend.origem = this.itemEditTransacao.origem;
      objSend.motivoCancelamentoExclusao = this.form.motivoCancelamentoExclusao;
      objSend.dataEmissao = this.itemEditTransacao.issueDate;
      objSend.dataVencimento = this.itemEditTransacao.dueDate;
      objSend.idAssociado = this.itemEditTransacao.insuredId;
      objSend.mesReferente = this.itemEditTransacao.referenceMonth;
      objSend.valorBoleto = this.itemEditTransacao.boletoValue;
      objSend.veiculos = this.data.vehicles;

      var send = false;
      if (acao != 'Alterar') send = true;
      else
        this.$validator.validateAll().then((result) => {
          if (result) {
            send = true;
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Existem campos não preenchidos',
              color: 'danger',
            });
          }
        });

      if (send == true) {
        this.$vs.loading();
        service
          .post('Financeiro', 'cadastrarCobrancaAcao', objSend)
          .then(() => {
            setTimeout(() => {
              if (acao == 'Reprocessa') {
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: `A Ação de Reprocessamento foi cadastrada com sucesso, e pode demorar alguns segundos, aguarde e depois clique no botao Refresh`,
                  color: 'success',
                });
              } else {
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: `Cobrança ${acao}da com Sucesso`,
                  color: 'success',
                });
              }
              this.closeModais();
              this.fetchData();
              this.$vs.loading.close();
            }, 100);
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.closeModais();
            this.$vs.loading.close();
          });
      }
    },
    async finalizaAvulsa() {
      this.$vs.loading();

      await Promise.all([
        this.getInsuredCreditCardCharges(),
        this.getInsuredBilletCharges(),
      ]);
      this.closeModais();

      this.$vs.loading.close();
    },
    openModalCobranca() {
      this.modalCobranca = true;
    },
    formataDataHora(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataData(data) {
      return data ? moment(data).format('DD/MM/YYYY') : null;
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    formataDataUTCAux(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    getStatusColor(data) {
      if (data == 'ATIVO') return 'success';
      if (data == null) return 'warning';
      if (data == 'INADIMPLENTE') return 'danger';
      if (data == 'Pendente') return 'primary';
      if (data == 'Finalizada') return 'dark';
      return 'danger';
    },
    getStatusBoletoColor(data) {
      const warning = ['ABERTO', 'BAIXADO COM PENDÊNCIA', 'Em Aberto'];

      const success = ['BAIXADO', 'Finalizado'];

      const danger = [
        undefined,
        '',
        'CANCELADO',
        'Cancelado',
        'Processado com Falha',
      ];

      const dark = ['EXCLUIDO', 'Não Processado', BilletStatuses.SETTLED];

      const primary = ['Em Processamento'];

      if (warning.includes(data)) return 'warning';
      if (success.includes(data)) return 'success';
      if (danger.includes(data)) return 'danger';
      if (dark.includes(data)) return 'dark';
      if (primary.includes(data)) return 'primary';
    },
    isNotLooseCreatedStatus(status) {
      return status !== 'created';
    },
    validaVencido(item) {
      if (
        item.status !== 'Finalizado' &&
        item.status !== 'Cancelado' &&
        item.status !== 'BAIXADO'
      ) {
        if (moment().diff(moment(item.dueDate), 'days') > 0) return true;
      }
      return false;
    },
    getStatusAtendimentoColor(idStatus) {
      if (idStatus === 1) return 'primary';
      if (idStatus === 2) return 'success';
      if (idStatus === 3) return 'warning';
      if (idStatus === 4) return 'danger';
      if (idStatus === 5) return 'danger';
      if (idStatus === 6) return 'dark';
      if (idStatus === 7) return '#7B49E7';
    },
    somaValorTotal(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal == false && element.situacao == 'ATIVO')
          total = total + element.valor;
      });
      return total;
    },
    somaValorTotalMes(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (
          (element.isMensal == true ||
            element.isMensal == undefined ||
            element.isMensal == null) &&
          element.situacao == 'ATIVO'
        )
          total = total + element.valor;
      });
      return total;
    },
    buscaDetalhesVeiculo(idVeiculo) {
      return new Promise(async (resolve) => {
        this.$vs.loading();
        var objSend = {};
        objSend.idVeiculo = idVeiculo;
        service.post('Veiculos', 'detalheVeiculo', objSend).then((res) => {
          var aux = res.data;
          this.$vs.loading.close();
          resolve(aux);
        });
      });
    },
    setProducts(policy) {
      this.autoProducts = functions.getContractedProductsWithDetails(
        policy.coverageContracted,
        policy.coverageOffered.prize,
      );
      const prize = {
        ...policy.coverageOffered.prize,
        details: policy.coverageOffered.prize.details.filter((produtct) =>
          policy.coverageOffered.selected_coverages.find(
            (selCov) => selCov.id === produtct.id,
          ),
        ),
      };
      this.prize = {
        prize: prize.prize,
        prizeWithoutInterest:
          Number(prize.tariff_prize) + Number(prize.iof_value),
        interest: prize.interest,
        iof: prize.iof_value,
      };
    },
    isShippingBillet(item) {
      return item.shippingBilletId && !item.remittanceId;
    },
    async fetchData() {
      await this.getInsured();
      if (this.error) {
        return;
      }
      await this.getInsuredPolicies();
      await this.getInsuredProposals();
      await this.getInsuredCreditCardCharges();
      await this.getInsuredBilletCharges();
      this.buscaFormasPagamentoDisponiveisMensal();
      if (this.data.policies && this.data.policies.length) {
        await this.getOccurrencys(this.apoliceId);
      }
    },
    async getInsured() {
      try {
        this.$vs.loading();
        this.data.insured = await insuredApi.getInsuredById(
          this.$route.params.idAssociado,
        );
        await this.getInsuredVehicles();
      } catch (err) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Segurado não encontrado',
          color: 'danger',
        });
        this.error = true;
        console.error(err);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getInsuredPolicies() {
      try {
        this.$vs.loading();
        this.data.policies = await insuredApi.getInsuredPolicies(
          this.$route.params.idAssociado,
        );
        if (this.data.policies && this.data.policies.length) {
          this.mainPolicyNumber = this.data.policies[0].activatedPolicyNumber;
          this.apoliceId = this.data.policies[0].id;
          this.policyType = this.data.policies[0].policyType;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getInsuredProposals() {
      try {
        this.$vs.loading();
        this.data.proposals = await insuredApi.getInsuredProposals(
          this.$route.params.idAssociado,
          this.mainPolicyNumber,
          this.policyType,
        );
      } catch (err) {
        console.error(err);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getInsuredCreditCardCharges() {
      try {
        this.data.creditCardPurchases =
          await insuredApi.getInsuredCreditCardCharges(
            this.$route.params.idAssociado,
            this.mainPolicyNumber,
            this.policyType,
          );
      } catch (err) {
        console.error(err);
      }
    },
    async getInsuredBilletCharges() {
      try {
        const result = await insuredApi.getInsuredBilletCharges(
          this.$route.params.idAssociado,
          this.mainPolicyNumber,
          this.policyType,
        );
        const mappedShippingBillets = result.shippingBillets.map((billet) => {
          return {
            ...billet,
            shippingBilletId: billet.id,
            billetType: {
              ticketType: billet.billetType,
            },
            boletoValue: billet.value,
            dueDate: billet.dueDate ? billet.dueDate.split('T')[0] : null,
            issueDate: dataFunctions.convertDateToISO(billet.issueDate),
          };
        });
        this.data.billets = [
          ...new Set([...result.billets, ...mappedShippingBillets]),
        ];
      } catch (err) {
        console.error(err);
      }
    },
    async getInsuredVehicles() {
      try {
        const vehicles = await insuredApi.getInsuredVehicles(
          this.$route.params.idAssociado,
        );
        if (!vehicles || !vehicles.length) {
          return;
        }
        for (const vehicle of vehicles) {
          this.data.vehicles.push(vehicle);
        }
        if (vehicles[0].policy.policyType === TIPO_APOLICE.AUTO) {
          this.isAuto = true;
          this.setProducts(vehicles[0].policy);
        }
      } catch (err) {
        console.error(err);
      }
    },
    openModalFotos(item) {
      this.$vs.loading();
      service
        .post('Veiculos', 'buscarFotos', { id_veiculo: item.id })
        .then((res) => {
          this.modalFotos = true;
          this.fotos = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    closeModais() {
      this.modalCobranca = false;
      this.modalLogErro = false;
      this.jsonError = null;
      this.modalCancelarCobranca = false;
      this.modalAlterarDadosCobranca = false;
      this.modalBaixarCobranca = false;
      this.itemEditTransacao = null;
      this.modalFotos = false;
      this.modalHistorico = false;
      this.modalHistoricoBoleto = false;
      this.modalExcluirCobranca = false;
      this.activeModalCadastroOcorrencias = false;
      this.modalLiquidarCobranca = false;
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaDadosAtivosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .post(model, `list`, {
          idEmpresa: this.idEmpresa,
          notDeleted: true,
          tipoStatus: 'VEÍCULOS',
        })
        .then((res) => {
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaFormasPagamentoDisponiveisMensal() {
      var objSend = {};
      objSend.idAssociado = this.$route.params.idAssociado;
      objSend.idEmpresa = this.idEmpresa;
      service
        .post('Financeiro', 'buscaFormasPagamentoDisponiveisMensal', objSend)
        .then((res) => {
          this.formasPagamentoMensal = [];

          this.formasPagamentoMensal.push({ label: 'Selecione', id: null });

          res.data.forEach((element) => {
            this.formasPagamentoMensal.push({
              label: element.nomePagamento,
              id: element.id_tipoPagamentoEmpresa,
            });
          });
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    buscaRestricoes() {
      return new Promise(async () => {
        service
          .getAll('Restricoes', {}, `list/idEmpresa=${this.form.idEmpresa}`)
          .then((res) => {
            var aux = res.data.filter((x) => x.deletedAt == null);
            this.restricoes = aux;
            this.restricoes.push({
              idRestricao: null,
              descricao: 'Nenhuma Restrição',
            });
          });
      });
    },
    verificaAlteracao(alteracoes) {
      let result;

      if (alteracoes) {
        if (
          alteracoes.find(
            (item) =>
              item.alteracao === 'VALOR' || item.alteracao === 'VENCIMENTO',
          )
        )
          result = 'ALTERADO';
      }

      return result;
    },
    formatDescriptionItem(item) {
      const descriptionChunks = [];

      if (item.description) {
        descriptionChunks.push(item.description);
      }

      if (item.installment != null) {
        descriptionChunks.push(item.installment);
      }

      if (item.boletoValue != null) {
        const valorFormatado = functions.formataReal(item.boletoValue);
        descriptionChunks.push(`- ${valorFormatado}`);
      }

      if (item.dueDate) {
        const dataFormatada = this.formatDate(item.dueDate);
        descriptionChunks.push(`- ${dataFormatada}`);
      }

      if (item.billetType && item.billetType.ticketType) {
        descriptionChunks.push(`- ${item.billetType.ticketType}`);
      }

      return descriptionChunks.join(' ');
    },
    buscaTiposBoletos() {
      service.getAll('boletos', {}, `buscar-tipos-boletos`).then(({ data }) => {
        data.forEach((element) => {
          element.id = element.idTipoBoleto;
          element.label = element.tipoBoleto;
          this.tiposBoletos.push(element);
        });
      });
    },
    verificaBg(item) {
      if (item.aprovada == null) return '';
      if (item.aprovada == true) return 'bg-success';
      if (item.aprovada == false) return 'bg-danger';
    },
    openModalFoto(tipo, item) {
      if (
        this.$can(
          'Editar Informações Da Proposta na Foto da Vistoria',
          this.subjectPermission,
        ) &&
        this.dadosProposta.idStatus != 4
      ) {
        this.disableSwitch = false;
      }
      this.preencheForm();
      this.imgModal = item.nome;
      this.isFullscreen = true;
      this.itemModal = item;
      this.tipoModal = 'Foto';
      this.itemModalIndex = this.fotos.findIndex(
        (foto) => foto == this.itemModal,
      );
      this.rotate = 'transform rotate-0';
      if (tipo == 'Padrão') {
        this.tipoModal = 'Padrão';
        this.imgModal =
          'https://bboneapp.s3.amazonaws.com/imgsPadrao/' + item.fotoPadrao;
        this.isFullscreen = false;
      }
      this.openModal = true;
    },
    verificaExtensaoArquivo(link) {
      return link ? link.split('.').pop() : false;
    },
    openModalBoletosExcluidos(boletos) {
      this.boletosExcluidos = boletos.filter(
        (item) => item.status === 'EXCLUIDO',
      );
    },
    abrirModalHistoricoAssociados(item) {
      this.dadosConsultaHistorico = [
        {
          tabela: 'associados',
          id: item.id,
        },
      ];
      this.tipoHistorico = 'Segurado';
      this.nomeHistorico = item.nome;
      this.popupActive = true;
    },
    fecharModalHistorico() {
      this.popupActive = false;
    },
    abriModalHistoricoBoleto(boleto) {
      this.dadosConsultaHistorico = boleto;
      this.modalHistoricoBoleto = true;
    },
    abriModalCadastroOcorrencias() {
      this.$refs.ModalCadastroOcorrencias.openModal();
    },
    fecharModalCadastroOcorrencias() {
      this.activeModalCadastroOcorrencias = false;
      this.getOccurrencys(this.apoliceId);
    },
    getProposalPdfContractLink(item) {
      if (item.policy.statusId !== POLICY_STATUSES.OPEN.id) {
        return item.policy.insurancePolicy;
      } else {
        return item.insuranceProposal;
      }
    },
    getOpenProposalLabel(policyStatus) {
      if (policyStatus !== POLICY_STATUSES.OPEN.id) {
        return 'Apólice';
      } else {
        return 'Proposta';
      }
    },
    getLinkContratoProposta(chave, apolice) {
      if (apolice == TIPO_APOLICE.VIDA) {
        return `/contratoPropostaVida/${chave}`;
      }
      return `/contratoProposta/${chave}`;
    },
    isLifePolicy(idTipoApolice) {
      return (
        idTipoApolice == TIPO_APOLICE.VIDA ||
        idTipoApolice == TIPO_APOLICE.MICRO_VIDA
      );
    },
    async getOccurrencys(policyId) {
      if (!this.permissaoOcorrenciaApolice) {
        return;
      }

      try {
        const occurrencies = await occurrenceApi.getPolicyOccurrences(policyId);
        this.ocorrencias = occurrencies;
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
      }
    },
    downloadFile(link) {
      fileDownload.download(window, link);
    },
    occurrencyTitle(date) {
      return functions.formatDateAndHour(date);
    },
    showAttachmentsLabel(attachment) {
      return Array.isArray(attachment) && attachment.length;
    },
    openModalCreditCardRefunds(purchaseId) {
      this.creditCardRefundPruchaseId = purchaseId;
      this.activeModalCreditCardRefund = true;
    },
    openModalCreditCardRefundsHitory(purchaseId) {
      this.creditCardRefundPruchaseId = purchaseId;
      this.activeModalCreditCardRefundHistory = true;
    },
    closeModalCreditCardRefunds(data) {
      this.activeModalCreditCardRefund = false;
      this.creditCardRefundPruchaseId = null;

      this.data.creditCardPurchases = this.data.creditCardPurchases.map(
        (item) =>
          item.id === data.purchaseId
            ? {
                ...item,
                status: data.status,
                creditCardRefunds: [...item.creditCardRefunds, ...data.refunds],
              }
            : item,
      );
    },
    closeModalCreditCardRefundsHistory() {
      this.activeModalCreditCardRefundHistory = false;
      this.creditCardRefundPruchaseId = null;
    },
    refundedStatusPurchases(status) {
      const refundedStatus = [
        PURCHASE_STATUS.PAID,
        PURCHASE_STATUS.PARTIALLY_CANCELED,
      ];

      return refundedStatus.includes(status);
    },
    hasCreditCardRefunds(refunds) {
      if (!refunds || !Array.isArray(refunds)) {
        return false;
      }

      return Array.isArray(refunds) && refunds.length > 0;
    },
  },
  mounted() {
    this.idEmpresa = localStorage.getItem('idEmpresa');
    this.fetchData();
    this.buscaDadosSelectsPorEmpresa(
      'regionais',
      'regionais',
      'nome',
      'idRegional',
    );
    this.buscaDadosSelectsPorEmpresa(
      'usuarios',
      'consultores',
      'nome',
      'idUsuario',
    );
    this.buscaDadosSelectsPorEmpresa(
      'gruposVeiculos',
      'grupos',
      'nomeGrupo',
      'idGrupo',
    );
    this.buscaRestricoes();
    this.buscaDadosSelectsPorEmpresa(
      'produtos',
      'produtos',
      'nomeProduto',
      'idProduto',
    );
    this.buscaTiposBoletos();
  },
};
</script>
<style scoped lang="scss">
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
.text-chip {
  font-size: 1.2rem;
}

.table-bordered {
  font-size: 1rem;
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.forceWhite:hover {
  color: #fff !important;
}

.truncText {
  max-width: 70ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style>
#popup-loose-charge.con-vs-popup .vs-popup {
  width: 50% !important;
}

.popup-loose-charge-overflow {
  overflow: visible;
}
</style>
